<script lang="ts">
	import { Container } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	let className = '';
	export { className as class };
	export let noBorder = false;
</script>

<Container
	padding="s"
	type="borderDashed"
	class={classMap({ [className]: true, 'border-color-transparent': noBorder })}
>
	<slot />
</Container>
